import { UiService } from '@core/services/ui/ui.service';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Observable } from 'rxjs';
import { AppService } from '../app/app.service';
import { TimeInvokingService } from '../time-invoking/time-invoking.service';
import { PushNotifications } from '@capacitor/push-notifications';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {
  private _deviceToken: string;

  get deviceToken(): string {
    return this._deviceToken;
  }

  constructor(
    private appService: AppService,
    private timeInvokingService: TimeInvokingService,
    private uiService: UiService
  ) {}

  /**
   * inzializza le notifiche push
   */
  init(): Promise<void> {
    return this.timeInvokingService.invokeOnce(
      'PushNotificationsServiceInit',
      async () => {
        if (!this.isPushNotificationsAvailable()) {
          return;
        }

        try {
          await this.guaranteePermissions();
          await this.registerDeviceToken();
        } catch (_) {
          console.log(_);
          this.uiService.showWarningToast(
            'Dispositivo non abilitato per ricevere le notifiche '
          );
        }

        this.getWhenTap().subscribe(res => this.openNotification(res));
      }
    );
  }

  /**
   * restituisce osservabile che emette evento quando viene ricevuta una notifica push
   */
  getWhenReceive(): Observable<any> {
    const observable = new Observable<any>(observer => {
      if (!this.isPushNotificationsAvailable()) {
        observer.complete();
        return;
      }

      PushNotifications.addListener(
        'pushNotificationReceived',
        notification => {
          observer.next(notification);
        }
      );
    });

    return observable;
  }

  /**
   * restituisce osservabile che emette evento quando viene ricevuta una notifica push
   */
  getWhenTap(): Observable<any> {
    const observable = new Observable<any>(observer => {
      if (!this.isPushNotificationsAvailable()) {
        observer.complete();
        return;
      }

      PushNotifications.addListener(
        'pushNotificationActionPerformed',
        action => {
          if (action.actionId === 'tap') {
            observer.next(action.notification);
          }
        }
      );
    });

    return observable;
  }

  /**
   * stabilisce se le notifiche push sono disponibili
   */
  isPushNotificationsAvailable(): boolean {
    return (
      this.appService.getConfig().security.pushNotificationActive &&
      Capacitor.isPluginAvailable('PushNotifications')
    );
  }

  /**
   * gestire l'apertura di una notifica
   */
  openNotification(notification: any): void {
    console.log(notification);
  }

  /**
   * controlla e richiedi i permessi se necessario
   */
  private async guaranteePermissions(): Promise<void> {
    let status = await PushNotifications.checkPermissions();

    if (status.receive === 'prompt') {
      status = await PushNotifications.requestPermissions();
    }

    if (status.receive !== 'granted') {
      throw new Error('User denied permissions!');
    }
  }

  /**
   * registra il device
   */
  private registerDeviceToken(): Promise<void> {
    return new Promise((resolve, reject) => {
      PushNotifications.addListener('registration', token => {
        this._deviceToken = token.value;
        resolve();
      });

      PushNotifications.addListener('registrationError', error => {
        this._deviceToken = undefined;
        reject(error);
      });

      PushNotifications.register();
    });
  }
}
